// LLM generated - Model Claude 4 Sonnet
type IconCoinAuroraProps = {
  size?: number;
  strokeWidth?: number;
};

export default function IconCoinAurora({ size = 28, strokeWidth = 2.5 }: IconCoinAuroraProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2667 10.5C17.0553 10.1334 16.7483 9.83119 16.3783 9.62569C16.0084 9.42018 15.5896 9.31914 15.1667 9.33337H12.8333C12.2145 9.33337 11.621 9.57921 11.1834 10.0168C10.7458 10.4544 10.5 11.0479 10.5 11.6667C10.5 12.2855 10.7458 12.879 11.1834 13.3166C11.621 13.7542 12.2145 14 12.8333 14H15.1667C15.7855 14 16.379 14.2459 16.8166 14.6835C17.2542 15.121 17.5 15.7145 17.5 16.3334C17.5 16.9522 17.2542 17.5457 16.8166 17.9833C16.379 18.4209 15.7855 18.6667 15.1667 18.6667H12.8333C12.4104 18.6809 11.9916 18.5799 11.6217 18.3744C11.2517 18.1689 10.9447 17.8667 10.7333 17.5M14 8.16667V19.8333M24.5 14C24.5 19.799 19.799 24.5 14 24.5C8.20101 24.5 3.5 19.799 3.5 14C3.5 8.20101 8.20101 3.5 14 3.5C19.799 3.5 24.5 8.20101 24.5 14Z"
        stroke="url(#paint0_linear_coin_aurora)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_coin_aurora"
          x1="3.5"
          y1="14"
          x2="24.5"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BC4CF" />
          <stop offset="1" stopColor="#7F1A93" />
        </linearGradient>
      </defs>
    </svg>
  );
}

IconCoinAurora.displayName = 'IconCoinAurora';
